<template>
  <div data-app>
    <template>
      <v-row v-if="!regDataIsComplte">
        <v-card width="100%">
          <v-card-title>وضعیت ثبت اطلاعات کسب و کار</v-card-title>
          <v-stepper width="100%">
            <v-stepper-header>
              <v-stepper-step
                :rules="[() => regStatus.step1]"
                step="1"
                :complete="regStatus.step1"
              >
                اطلاعات مدیریتی
              </v-stepper-step>

              <v-divider></v-divider>
              <v-stepper-step
                :rules="[() => regStatus.step2]"
                step="2"
                :complete="regStatus.step2"
              >
                اطلاعات حقوقی
              </v-stepper-step>

              <v-divider></v-divider>
              <v-stepper-step
                :rules="[() => regStatus.step3]"
                step="3"
                :complete="regStatus.step3"
              >
                آدرس
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                :rules="[() => regStatus.step4]"
                step="4"
                :complete="regStatus.step4"
              >
                حوزه فعالیت
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                :rules="[() => regStatus.step5]"
                step="5"
                :complete="regStatus.step5"
              >
                لوگو و تصاویر
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step
                :rules="[() => regStatus.step6]"
                step="6"
                :complete="regStatus.step6"
              >
                معرفی کسب و کار
              </v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </v-card>
      </v-row>
      <div v-if="dataLoaded" class="mt-4" :sticky="true">
        <div class="w-100 d-flex flex-wrap flex-row justify-content-between">
          <v-spacer></v-spacer>

          <div class="d-flex flex-wrap gap-0-5">
            <v-btn
              v-if="merchantInformation.status != 'Approved'"
              color="blue"
              class="mx-1 white--text"
              @click="gotoEditMerchant()"
            >
              ویرایش
              <v-icon right dark> mdi-pencil</v-icon>
            </v-btn>

            <div
              class="d-flex flex-row"
              v-else-if="merchantInformation.status == 'Approved'"
            >
              <HelperComponent
                helperId="How-to-request-edit-merchant"
                class="mt-1"
              />
              <v-btn
                color="blue"
                class="mx-1 white--text"
                @click="gotoEditMerchant()"
              >
                درخواست ویرایش
                <v-icon right dark> mdi-pencil</v-icon>
              </v-btn>
            </div>
            <transition name="fade">
              <v-btn
               :disabled="!regDataIsComplte"
                color="blue"
                v-if="
                  merchantInformation.status == 'Draft' ||
                  merchantInformation.status == 'Rejected'
                "
                class="white--text"
                @click="sendRequestForConfirmation()"
              >
                ارسال جهت تایید و انتشار
              </v-btn>
            </transition>

            <v-btn
              color="blue"
              class="mx-1 white--text"
              @click="
                $router.push({
                  path: `/merchant-companies/list`,
                })
              "
            >
              لیست کسب و کارها
            </v-btn>
          </div>
        </div>

        <business-information-user-info
          :userBusinessInformation="merchantInformation"
        ></business-information-user-info>
        <business-information-company-info
          :userBusinessInformation="merchantInformation"
          :showStatus="true"
        ></business-information-company-info>
        <business-information-address-info
          :userBusinessInformation="merchantInformation"
        ></business-information-address-info>
        <business-information-category
          :merchantCategoriesBreadCrumbList="merchantCategoriesBreadCrumbList"
        ></business-information-category>
        <business-information-other-info
          :userBusinessInformation="merchantInformation"
        ></business-information-other-info>
      </div>
    </template>
    <v-dialog v-model="rejectionMessageDialog" max-width="500px">
      <BaseCard>
        <template v-slot:header>
          <span style="color: hsl(220deg 15% 60%)"
            ><v-icon>mdi-information</v-icon> دلیل رد کسب و کار
          </span>
          <v-spacer></v-spacer>

          <v-btn
            @click="rejectionMessageDialog = false"
            icon
            color="blue-grey lighten-3"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </template>
        <template>
          <v-container>
            <v-row>
              <v-col cols="12">
                <ValidationProvider
                  ref="rejectMessageObs"
                  name="پیام رد کسب و کار:"
                  rules="required"
                >
                  <v-textarea
                    slot-scope="{ errors }"
                    :error-messages="errors"
                    outlined
                    v-model="rejectionMessage"
                    label="پیام رد کسب و کار:"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="pt-md-0">
                <v-btn color="blue" dark @click="rejectMerchant()">
                  رد کسب و کار
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </BaseCard>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { RepoFactory } from '@/baseRepository/Factory';
import Swal from 'sweetalert2';
import Helper from '@/core/helpers';
const merchantRepository = () => RepoFactory.get('merchant');
const merchantCompanyRepository = () => RepoFactory.get('merchantCompany');
const categoryRepository = () => RepoFactory.get('category');
import BusinessInformationUserInfo from '@/components/businessInformation/showDetail/BusinessInformationUserInfo.vue';
import BusinessInformationCompanyInfo from '@/components/businessInformation/showDetail/BusinessInformationCompanyInfo.vue';
import BusinessInformationAddressInfo from '@/components/businessInformation/showDetail/BusinessInformationAddressInfo.vue';
import BusinessInformationOtherInfo from '@/components/businessInformation/showDetail/BusinessInformationOtherInfo.vue';
import BusinessInformationCategory from '@/components/businessInformation/showDetail/BusinessInformationCategory.vue';
export default {
  name: 'MerchantCompanyInformation',
  components: {
    BusinessInformationUserInfo,
    BusinessInformationCompanyInfo,
    BusinessInformationAddressInfo,
    BusinessInformationOtherInfo,
    BusinessInformationCategory,
  },
  data() {
    return {
      items: [],
      rejectionMessageDialog: false,
      rejectionMessage: null,
      merchantCategoriesBreadCrumbList: [],
      merchantStatusList: [],
      categoryTypeItemsList: [],
      merchantSocialMediaList: [],
      merchantSizeTypeList: [],
      dataLoaded: false,
      merchantInformation: null,
      loader: null,
      regStatus: {
        step1: false, // manager info
        step2: false, // merchat company type
        step3: false, //address
        step4: false, // categories
        step5: false, // logo images
        step6: false, //about
      },
      regDataIsComplte: false,
    };
  },
  computed: {
    ...mapGetters(['productBaseUrl', 'merchantBaseUrl']),
  },
  created() {
    this.getMerchantInformationById();
  },
  methods: {
    getMerchantInformationById() {
      const loader = this.$loading.show();
      merchantCompanyRepository()
        .getMerchantInformationById(this.$route.params.id, this.merchantBaseUrl)
        .then(({ data }) => {
          this.merchantInformation = data;
            this.CheckRegStatuse(data);
          this.$store.commit('setSelectedMerchantCompany', data);
          if (data.managerPerson === null) {
            this.$router.push({ path: '/management/merchants' }).then(() => {
              Swal.fire({
                icon: 'error',
                title: 'اطلاعات این کسب و کار ناقص است !!',
                confirmButtonText: ' بستن',
              });
            });
          }
          this.getMerchantCategoriesBreadCrumb();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getMerchantCategoriesBreadCrumb() {
      const loader = this.$loading.show();
      categoryRepository()
        .getMerchantCategoriesBreadCrumb(this.productBaseUrl, {
          merchantId: this.merchantInformation.merchantId,
        })
        .then(({ data }) => {
          this.merchantCategoriesBreadCrumbList = data;
          this.dataLoaded = true;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    gotoEditMerchant() {
      this.$router.push(
        `/merchant-companies/${this.merchantInformation.merchantId}/edit`
      );
    },

    sendRequestForConfirmation() {
      if (!this.regDataIsComplte) {
        Swal.fire({
          icon: 'warnin',
          title:
            ' قبل از ارسال اطلاعات آنرا کامل کنید. به راهنمای وضعیت اطلاعات توجه فرمایید  ',
          confirmButtonText: ' بستن',
        });
        return;
      }
      Swal.fire({
        html: `اطلاعات شما جهت تایید به پشتیبانی ارسال میشود`,
        icon: 'warning',
        confirmButtonText: ' بلی',
        showCancelButton: true,
        cancelButtonText: 'خیر',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show();
          merchantRepository()
            .merchantRequestConfirmation(
              this.merchantInformation.merchantId,
              this.merchantBaseUrl
            )
            .then(() => {
              this.merchantInformation.status = 'InProgress';
              Swal.fire({
                icon: 'success',
                title:
                  'ارسال درخواست با موفقیت انجام شد نتیجه به اطلاع شما خواهد رسید',
                confirmButtonText: ' بستن',
              });
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
            .finally(() => loader.hide());
        }
      });
    },
    CheckRegStatuse(merchant) {
      // step1: true,// manager info
      // step2: true,// merchat company type
      // step3: false,//address
      // step4: true,// categories
      // step5: false,//  logo images
      // step6: false,//  about
      //console.log("merchant data is ", merchant)
      if (
        merchant.managerPerson != null &&
        merchant.managerPerson.mobile.length != 10
      ) {
        this.regStatus.step1 = true;
      }
      if (merchant.company != null && merchant.company.companyType) {
        this.regStatus.step2 = true;
      }
      if (merchant.address != null && merchant.address.cityId) {
        this.regStatus.step3 = true;
      }
      if (
        merchant.merchantCategories != null &&
        merchant.merchantCategories.length > 0
      ) {
        this.regStatus.step4 = true;
      }
      if (merchant.logo != null && merchant.images.length > 0) {
        this.regStatus.step5 = true;
      }
      if (merchant.about != null && merchant.about.length > 60) {
        this.regStatus.step6 = true;
      }
      if (
        this.regStatus.step1 &&
        this.regStatus.step2 &&
        this.regStatus.step3 &&
        this.regStatus.step4 &&
        this.regStatus.step5 &&
        this.regStatus.step6
      ) {
        this.regDataIsComplte = true;
      } else {
        this.regDataIsComplte = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#refreshButton {
  position: absolute;
  bottom: 20px;
  left: 20px;
  padding: 10px;
  z-index: 400;
}
</style>
